import { render, staticRenderFns } from "./InfoDocument.vue?vue&type=template&id=3563f632&scoped=true"
import script from "./InfoDocument.vue?vue&type=script&lang=js"
export * from "./InfoDocument.vue?vue&type=script&lang=js"
import style0 from "./InfoDocument.vue?vue&type=style&index=0&id=3563f632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3563f632",
  null
  
)

export default component.exports